import { useRef, useState } from 'react';
import {
  MASSIMO_DESTINATARI,
  MASSIMO_PREAVVISI,
  erroriPromemoria,
  formDaConfigurazione,
} from './promemoriaScadenze';

// The messages of one list, by the `id` of its row instead of its position.
const perRiga = (righe, messaggi = []) =>
  Object.fromEntries(righe.map((riga, indice) => [riga.id, messaggi[indice]]));

/**
 * The editing state of the dialog, started from the saved configuration. Every
 * row of the two lists carries an `id` of its own, so that removing the first
 * one does not hand its value to the next. An empty list of destinatari shows
 * one empty row: there is always a field to type the first address in.
 *
 * Errors show from the first Salva on, and from then follow what is typed: a
 * corrected field loses its message at once, a removed row takes its message
 * with it. They are keyed by the row's `id`, like the rows.
 */
const useFormPromemoria = (configurazione) => {
  const prossimoId = useRef(0);
  const riga = (valore) => {
    prossimoId.current += 1;
    return { id: prossimoId.current, valore };
  };

  const [form, setForm] = useState(() => {
    const iniziale = formDaConfigurazione(configurazione);
    return {
      attivo: iniziale.attivo,
      preavvisi: iniziale.preavvisi.map(riga),
      destinatari: (iniziale.destinatari.length
        ? iniziale.destinatari
        : ['']
      ).map(riga),
    };
  });
  const [verificato, setVerificato] = useState(false);

  const cambia = (cambiamento) =>
    setForm((attuale) => ({ ...attuale, ...cambiamento(attuale) }));

  const lista = (campo, massimo) => ({
    cambia: (indice, valore) =>
      cambia((attuale) => ({
        [campo]: attuale[campo].map((elemento, i) =>
          i === indice ? { ...elemento, valore } : elemento,
        ),
      })),
    aggiungi: () =>
      cambia((attuale) => ({
        [campo]:
          attuale[campo].length >= massimo
            ? attuale[campo]
            : [...attuale[campo], riga('')],
      })),
    rimuovi: (indice) =>
      cambia((attuale) => ({
        [campo]: attuale[campo].filter((_, i) => i !== indice),
      })),
  });

  const valori = () => ({
    attivo: form.attivo,
    preavvisi: form.preavvisi.map((elemento) => elemento.valore),
    destinatari: form.destinatari.map((elemento) => elemento.valore),
  });

  const trovati = erroriPromemoria(valori());
  const errori = verificato
    ? {
        preavvisi: perRiga(form.preavvisi, trovati.preavvisi),
        destinatari: perRiga(form.destinatari, trovati.destinatari),
      }
    : { preavvisi: {}, destinatari: {} };

  /** Shows the errors on the fields from now on, answers whether the form is valid. */
  const valida = () => {
    setVerificato(true);
    return Object.keys(trovati).length === 0;
  };

  return {
    form,
    errori,
    cambiaAttivo: (attivo) => cambia(() => ({ attivo })),
    preavvisi: lista('preavvisi', MASSIMO_PREAVVISI),
    destinatari: lista('destinatari', MASSIMO_DESTINATARI),
    valori,
    valida,
  };
};

export default useFormPromemoria;
